import React, { createContext, useState, useEffect } from "react";

// Cria o contexto do tema
export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [temaEscuro, setTemaEscuro] = useState(() => {
    try {
      const temaSalvo = localStorage.getItem("temaEscuro");
      return temaSalvo ? JSON.parse(temaSalvo) : true;
    } catch {
      return true;
    }
  });

  const alternarTema = () => {
    setTemaEscuro((prev) => {
      const novoTema = !prev;
      localStorage.setItem("temaEscuro", JSON.stringify(novoTema));
      return novoTema;
    });
  };

  useEffect(() => {
    const root = document.documentElement;
    if (temaEscuro) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [temaEscuro]);

  return <ThemeContext.Provider value={{ temaEscuro, alternarTema }}>{children}</ThemeContext.Provider>;
}
